/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { GetV1UsersAddressesQueryResponse } from "../../../types/GetV1UsersAddresses.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getGetV1UsersAddressesUrlClient() {
  const res = { method: 'GET', url: `/v1/users/addresses` as const }
  return res
}

/**
 * @summary List user's addresses
 * {@link /v1/users/addresses}
 */
export async function getV1UsersAddressesClient(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetV1UsersAddressesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetV1UsersAddressesUrlClient().url.toString(), ... requestConfig })
  return res
}